import { useHistory, useLocation } from 'react-router-dom';
import { useCallback } from 'react';
export const useSetLocationStateAction = (key, initialValue) => {
    const history = useHistory();
    return useCallback((value) => {
        const { state = {} } = history.location;
        const newValue = typeof value === 'function'
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                value === null || value === void 0 ? void 0 : value((state === null || state === void 0 ? void 0 : state[key]) || initialValue)
            : value;
        history.replace(Object.assign(Object.assign({}, history.location), { state: Object.assign(Object.assign({}, state), { [key]: newValue }) }));
    }, [history, initialValue, key]);
};
const useLocationState = (key, initialValue) => {
    const { state = {} } = useLocation();
    const setLocationState = useSetLocationStateAction(key, initialValue);
    const value = state[key] || initialValue;
    return { value, setLocationState };
};
export default useLocationState;
